import React from "react";
import time from "../Images/Icons/clock.png";
import destination from "../Images/Icons/destination.png";
import line from "../Images/Icons/line.png";

export const BusesSectionHeader = props => {
  

  return (
    <thead className="timetable-header">
                  <tr>
                    <th>
                      <img
                        className="timetable-icon"
                        src={time}
                        alt="clock icon"
                      />
                      <span className="trainstop-header__title">Czas</span>
                    </th>
                    <th>
                      <div className="d-flex align-items-center">
                        <img
                          className="timetable-icon"
                          src={destination}
                          alt="destination icon"
                        />
                        <div className="trainstop-header__title">Do</div>
                        <div className="line"></div>
                      </div>
                    </th>
                    <th>
                      <img
                        className="timetable-icon"
                        src={line}
                        alt="line icon"
                      />
                      <span className="trainstop-header__title">Linia</span>
                    </th>
                  </tr>
                </thead>
  );
};



